// Wspólny szkielet dolnego arkusza (nakładka + karta), ten sam wygląd co panel
// stroju (`ui/stroj.ts`, klasy `.zar-stroj-*`). Arkusz jest dołączany do
// `document.body`, nie do `#app`, z tego samego powodu co panel stroju:
// przeliczenie treści utworu nie może go zniszczyć.

const KLASA = 'zar-stroj-nakladka';

export interface Arkusz {
  karta: HTMLDivElement;
  zamknij: () => void;
  /** `true`, dopóki arkusz wisi w dokumencie. Zamknąć go może też inny panel
   * (otwarcie nowego zdejmuje stary), więc właściciel pętli audio sprawdza to
   * sam, zamiast polegać wyłącznie na własnym `zamknij`. */
  otwarty: () => boolean;
}

export function otworzArkusz(tytul: string, naZamkniecie?: () => void): Arkusz {
  document.querySelector(`.${KLASA}`)?.remove();

  const naklad = document.createElement('div');
  naklad.className = KLASA;
  const karta = document.createElement('div');
  karta.className = 'zar-stroj-karta';
  naklad.appendChild(karta);

  const naglowek = document.createElement('p');
  naglowek.className = 'zar-stroj-naglowek';
  naglowek.textContent = tytul;
  karta.appendChild(naglowek);

  let zamkniety = false;
  const zamknij = (): void => {
    if (zamkniety) return;
    zamkniety = true;
    naklad.remove();
    naZamkniecie?.();
  };
  naklad.addEventListener('click', (z) => { z.stopPropagation(); zamknij(); });
  karta.addEventListener('click', (z) => z.stopPropagation());

  document.body.appendChild(naklad);
  return { karta, zamknij, otwarty: () => !zamkniety && naklad.isConnected };
}

/** Przycisk „gotowe" zamykający arkusz, w wierszu akcji na dole karty. */
export function dodajGotowe(arkusz: Arkusz): void {
  const akcje = document.createElement('div');
  akcje.className = 'zar-stroj-akcje';
  const gotowe = document.createElement('button');
  gotowe.type = 'button';
  gotowe.className = 'zar-przycisk zar-przycisk--glowny';
  gotowe.textContent = 'gotowe';
  gotowe.addEventListener('click', (z) => { z.stopPropagation(); arkusz.zamknij(); });
  akcje.appendChild(gotowe);
  arkusz.karta.appendChild(akcje);
}
